enum BillType {
  Subscription = "Subscription",
  Manual = "Manual"
}
export default BillType